module.exports = __webpack_public_path__ + "media/images/Menu burgerblanc-67cbd4795e6b66f800118e43217991cb.svg";